import { saveDriver } from "../api.ts";
import { useMutation } from "@tanstack/react-query";

import type { SaveDriverRequest } from "../../types.ts";

// Mutation hook for saving a driver (create or update)
export const useSaveDriverMutation = () => {
  return useMutation({
    mutationFn: async (data: SaveDriverRequest) => {
      const response = await saveDriver(data);
      return response.data;
    },
  });
};
